(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/challenge/assets/javascripts/components/betslip/betslip-payoptions.js') >= 0) return;  svs.modules.push('/modules/challenge/assets/javascripts/components/betslip/betslip-payoptions.js');
"use strict";


const _ReactRedux = ReactRedux,
  useDispatch = _ReactRedux.useDispatch,
  useSelector = _ReactRedux.useSelector;
const toggleOverview = svs.challenge.actions.toggleOverview;
const _svs$ui = svs.ui,
  Button = _svs$ui.Button,
  ReactIcon = _svs$ui.ReactIcon;
const BetslipPayOptions = _ref => {
  let amounts = _ref.amounts,
    chosenBetPrice = _ref.chosenBetPrice,
    selectBetAmount = _ref.selectBetAmount,
    draw = _ref.draw;
  const isOverviewOpen = useSelector(state => state.isOverviewOpen);
  const dispatch = useDispatch();
  function handleOverviewClick() {
    dispatch(toggleOverview());
  }
  const overviewButton = React.createElement(Button, {
    block: true,
    className: "betslip-overview",
    iconPosition: "right",
    onClick: handleOverviewClick,
    size: 300,
    transparent: true
  }, React.createElement(ReactIcon, {
    icon: "viewsummary",
    size: "300"
  }), isOverviewOpen ? 'Dölj översikt av spelet' : 'Visa översikt av spelet');
  const betAmounts = amounts.map((amount, i) => React.createElement("div", {
    className: "form-toggle form-toggle-group-200",
    key: amount
  }, React.createElement("input", {
    checked: amount == chosenBetPrice,
    className: "form-toggle-input form-toggle-radio form-toggle-default form-toggle-button",
    id: "radio-".concat(i),
    name: "amountRadio",
    onChange: () => selectBetAmount(draw.drawNumber, amount),
    type: "radio",
    value: amount
  }), React.createElement("label", {
    className: "form-label",
    htmlFor: "radio-".concat(i)
  }, React.createElement("div", {
    className: "form-label-text"
  }, amount, ' ', "kr"))));
  return React.createElement("div", {
    className: "padding-1 bg-grey-100"
  }, React.createElement("div", {
    className: "padding-bottom-2"
  }, overviewButton), React.createElement("div", {
    className: "form-toggle-group form-toggle-group-200"
  }, betAmounts));
};
svs.challenge.BetslipPayOptions = BetslipPayOptions;

 })(window);